// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"11":"f73341f3","71":"8adb569f","398":"46c1b830","521":"8deb2689","665":"ee30cd20","815":"d02c156d"}[chunkId] + ".js";
};